import { createContext } from 'react';
import { CopilotContextData, CopilotContextState, CopilotScope } from './types';

// Context interface defining the state and methods available
export interface CopilotContextInterface extends CopilotContextState {
  // Get full data for a domain+feature scope
  getDomainData: (scope: CopilotScope) => CopilotContextData | undefined;

  // Set full data for a domain+feature scope
  setDomainData: (scope: CopilotScope, data: CopilotContextData) => void;

  // Get a specific key from a domain+feature scope
  getKey: <T>(scope: CopilotScope, key: keyof CopilotContextData) => T | undefined;

  // Set a specific key for a domain+feature scope
  setKey: <T>(scope: CopilotScope, key: keyof CopilotContextData, value: T) => void;

  // Get ref for a specific domain and feature
  getRef: (scope: CopilotScope) => any | null | undefined;

  // Set ref for a specific domain and feature
  setRef: (scope: CopilotScope, value: any) => void;
}

// Create context with default values
export const CopilotContext = createContext<CopilotContextInterface | null>(null);
